import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { oneLineTrim } from 'common-tags';
import { anniversaryCustomField, birthdayCustomField, superpowerCustomField } from './custom-profile-field';
import { allNotificationsEnabled } from './notification-preferences';
import { facebookConnected, linkedinExpired, twitterDisconnected } from './social-account';
export var address123 = {
  country: 'Canada',
  fullName: 'Bob Tester',
  address: '123 Tester Street',
  address2: 'Unit 221B',
  city: 'Toronto',
  region: 'Ontario',
  postalCode: 'A1B 2C3',
  phoneNumber: '123-456-7890'
}; // Used in rewards details

export var shippingAddress123 = _objectSpread({
  __typename: 'Address'
}, address123);
export var memberInfo456 = {
  id: '456',
  name: 'Kurt Wagner',
  username: 'nightcrawler',
  email: 'nightcrawler@xmen.com',
  title: 'Nightcrawler',
  company: 'The X-Men',
  language: {
    id: '1',
    name: 'English',
    displayName: 'English',
    code: 'en'
  },
  avatarUrl: 'https://s3.amazonaws.com/influitiveimagesdevelopment/app/contacts/original/61.jpg?1596637829',
  timezone: 'Eastern Time (US & Canada)',
  customFields: [anniversaryCustomField, birthdayCustomField, superpowerCustomField]
};
export var profile456 = _objectSpread(_objectSpread({}, memberInfo456), {}, {
  currentPoints: 234,
  lifetimePoints: 1000,
  level: {
    id: '3',
    name: 'Sidekick level'
  },
  nextLevel: {
    level: {
      id: '4',
      name: 'Super level'
    },
    requiredBadgesCount: 10,
    earnedBadgesCount: 3
  },
  shippingAddress: shippingAddress123,
  company: 'The X-Men',
  avatarUrl: 'https://s3.amazonaws.com/influitiveimagesdevelopment/app/contacts/original/61.jpg?1596637829',
  timezone: 'Eastern Time (US & Canada)',
  customFields: [anniversaryCustomField, birthdayCustomField, superpowerCustomField],
  socialAccounts: [twitterDisconnected, facebookConnected, linkedinExpired],
  notificationPreferences: allNotificationsEnabled,
  isAdmin: false,
  isClone: false
});
export var updatedProfile = _objectSpread(_objectSpread({}, profile456), {}, {
  socialAccounts: [{
    __typename: 'Twitter',
    id: 'TWITTER',
    connected: true,
    authUrl: oneLineTrim(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        https://app.influitives.com/users/auth/twitter?\n        custom_authenticity_token=e8dac3481e8a21ad746ea8328473e3a613fb7709b7cbc1e2b3ad25e956114a8d\n        &origin=http%3A%2F%2Fmadeleine.influitives.com%2Fprofiles%2Fbea5cc69-7878-47a0-bab6-1c02066e901e\n        &source=\n      "])))
  }, {
    __typename: 'Facebook',
    id: 'FACEBOOK',
    connected: true,
    authUrl: oneLineTrim(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        https://app.influitives.com/users/auth/facebook?\n        custom_authenticity_token=d85ee4d6165e2cc762f5501e27c2cc47f6a32711233ccd72f100613de452080a\n        &origin=http%3A%2F%2Fmadeleine.influitives.com%2Fprofiles%2Fbea5cc69-7878-47a0-bab6-1c02066e901e\n        &source=\n      "])))
  }, {
    __typename: 'Linkedin',
    id: 'LINKEDIN',
    connected: true,
    authUrl: oneLineTrim(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n        https://app.influitives.com/users/auth/linkedin?\n        custom_authenticity_token=cd31e2c5aed802754607cfda056bf81c64160839e417ba69a50a03fb1d906f68\n        &origin=http%3A%2F%2Fmadeleine.influitives.com%2Fprofiles%2Fbea5cc69-7878-47a0-bab6-1c02066e901e\n        &source=\n      "])))
  }]
});